const emitter = (val) => JSON.stringify(val)
export default emitter